import { useSearchParams } from "react-router-dom";
import BaseTableSkeleton from "views/components/base-table-skeleton";

const TransactionSkeleton = () => {
  const [searchParams] = useSearchParams();
  const walletId = searchParams.get("wallet-id");
  const userId = searchParams.get("user-id");

  const getColumns = () => {
    if (!userId && !walletId) {
      return Array(12).fill({ type: "text" });
    }
    if (userId) {
      return Array(8).fill({ type: "text" });
    }
    if (walletId) {
      return Array(7).fill({ type: "text" });
    }
    return [];
  };

  return <BaseTableSkeleton columns={getColumns()} />;
};

export default TransactionSkeleton;
